import { useContext } from 'react'

import { LessonViewModelContext } from './provider'

/**
 * LessonViewModel Hook
 *
 * Context에서 ViewModel을 가져옴
 * LessonViewModelProvider 내부에서만 사용 가능
 */
export const useLessonViewModel = () => {
  const context = useContext(LessonViewModelContext)

  if (!context) {
    throw new Error('useLessonViewModel must be used within LessonViewModelProvider')
  }

  return context
}
